var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z","key":1})]);
}

Icon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Icon;

Icon.default = Icon;
